import React from "react";
import "./ContactUs.css";
import { Container, Row, Col } from "react-bootstrap";
import { Map, ContactUs } from "../../Features/Home";
import { Header, Features } from "../../Features/About";

const ContactPage = ({ url, data }) => {

  const getInTouchSection = data?.find(
    (item) => item.section === "Get In Touch Section"
  );



  return (
    <div className="contact-page">

      {getInTouchSection && <ContactUs url={url} section={getInTouchSection} />}
    </div>
  );
};

export default ContactPage;
